<div [ngClass]="{animatedScreen: animate}" class="screen">
	<app-chat [ngClass]="{animatedChat: animate}" class="chat"> </app-chat>
	<button class="open-button" (click)="animate = !animate" [ngClass]="{animatedButton: animate}">
		<mat-icon class="open-icon"> chevron_left </mat-icon>
	</button>
	<app-employee-data (animationTrigger)="animate = $event" class="employeeData"> </app-employee-data>
</div>
